export const WWRatings = [
  {
    id: 1,
    name: 'Aalto',
    slug: 'aalto',
    toa_cat: 'dps',
    toa_rating: 6,
    toa_tags: 'Multirole, ST',
    ww_cat: 'hybrid',
    ww_rating: 6,
    ww_tags: 'ST',
    rarity: 4,
    element: 'Aero',
    weapon: 'Pistols'
  },
  {
    id: 2,
    name: 'Baizhi',
    slug: 'baizhi',
    toa_cat: 'support',
    toa_rating: 8,
    toa_tags: 'Coord, Heal',
    ww_cat: 'support',
    ww_rating: 8,
    ww_tags: 'Coord, Heal',
    rarity: 4,
    element: 'Glacio',
    weapon: 'Rectifier'
  },
  {
    id: 3,
    name: 'Brant',
    slug: 'brant',
    toa_cat: 'hybrid',
    toa_rating: 9,
    toa_tags: 'Cleave, Heal, Shield, Multirole',
    ww_cat: 'hybrid',
    ww_rating: 10,
    ww_tags: 'Cleave, Heal, Shield, Multirole',
    rarity: 5,
    element: 'Fusion',
    weapon: 'Sword'
  },
  {
    id: 4,
    name: 'Calcharo',
    slug: 'calcharo',
    toa_cat: 'dps',
    toa_rating: 7,
    toa_tags: 'Cancel, Expert +2, ST, Ult',
    ww_cat: 'dps',
    ww_rating: 6,
    ww_tags: 'Cancel, Expert +2, ST, Ult',
    rarity: 5,
    element: 'Electro',
    weapon: 'Broadblade'
  },
  {
    id: 5,
    name: 'Camellya',
    slug: 'camellya',
    toa_cat: 'dps',
    toa_rating: 10,
    toa_tags: 'AoE',
    ww_cat: 'dps',
    ww_rating: 11,
    ww_tags: 'AoE',
    rarity: 5,
    element: 'Havoc',
    weapon: 'Sword'
  },
  {
    id: 6,
    name: 'Carlotta',
    slug: 'carlotta',
    toa_cat: 'dps',
    toa_rating: 11,
    toa_tags: 'Cleave, Ult',
    ww_cat: 'dps',
    ww_rating: 10,
    ww_tags: 'Cleave, Ult',
    rarity: 5,
    element: 'Glacio',
    weapon: 'Pistols'
  },
  {
    id: 31,
    name: 'Cantarella',
    slug: 'cantarella',
    toa_cat: 'hybrid',
    toa_rating: 9,
    toa_tags: 'Cleave, Coord, Heal',
    ww_cat: 'hybrid',
    ww_rating: 8,
    ww_tags: 'Cleave, Coord, Heal',
    rarity: 5,
    element: 'Havoc',
    weapon: 'Rectifier'
  },
  {
    id: 7,
    name: 'Changli',
    slug: 'changli',
    toa_cat: 'hybrid',
    toa_rating: 9,
    toa_tags: 'Cancel, Cleave, Expert +2, Multirole',
    ww_cat: 'dps',
    ww_rating: 11,
    ww_tags: 'Cancel, Cleave, Multirole',
    rarity: 5,
    element: 'Fusion',
    weapon: 'Sword'
  },
  {
    id: 8,
    name: 'Chixia',
    slug: 'chixia',
    toa_cat: 'dps',
    toa_rating: 7,
    toa_tags: 'ST',
    ww_cat: 'dps',
    ww_rating: 7,
    ww_tags: 'ST, Ult',
    rarity: 4,
    element: 'Fusion',
    weapon: 'Pistols'
  },
  {
    id: 9,
    name: 'Danjin',
    slug: 'danjin',
    toa_cat: 'hybrid',
    toa_rating: 8,
    toa_tags: 'Cleave, Expert +1, Heal, Multirole',
    ww_cat: 'hybrid',
    ww_rating: 8,
    ww_tags: 'Cleave, Heal',
    rarity: 4,
    element: 'Havoc',
    weapon: 'Sword'
  },
  {
    id: 10,
    name: 'Encore',
    slug: 'encore',
    toa_cat: 'dps',
    toa_rating: 9,
    toa_tags: 'Expert +1, ST, Ult',
    ww_cat: 'dps',
    ww_rating: 8,
    ww_tags: 'Expert +1, ST, Ult',
    rarity: 5,
    element: 'Fusion',
    weapon: 'Rectifier'
  },
  {
    id: 11,
    name: 'Jianxin',
    slug: 'jianxin',
    toa_cat: 'hybrid',
    toa_rating: 7,
    toa_tags: 'AoE, Heal, Multirole, Shield',
    ww_cat: 'hybrid',
    ww_rating: 7,
    ww_tags: 'AoE, Heal, Multirole, Shield',
    rarity: 5,
    element: 'Aero',
    weapon: 'Gauntlets'
  },
  {
    id: 12,
    name: 'Jinhsi',
    slug: 'jinhsi',
    toa_cat: 'dps',
    toa_rating: 11,
    toa_tags: 'AoE, Coord',
    ww_cat: 'dps',
    ww_rating: 8,
    ww_tags: 'AoE, Coord, Expert +2',
    rarity: 5,
    element: 'Spectro',
    weapon: 'Broadblade'
  },
  {
    id: 13,
    name: 'Jiyan',
    slug: 'jiyan',
    toa_cat: 'dps',
    toa_rating: 9,
    toa_tags: 'AoE, Ult, Expert +1',
    ww_cat: 'dps',
    ww_rating: 11,
    ww_tags: 'AoE, Ult',
    rarity: 5,
    element: 'Aero',
    weapon: 'Broadblade'
  },
  {
    id: 14,
    name: 'Lingyang',
    slug: 'lingyang',
    toa_cat: 'dps',
    toa_rating: 6,
    toa_tags: 'ST, Ult',
    ww_cat: 'dps',
    ww_rating: 6,
    ww_tags: 'ST, Ult',
    rarity: 5,
    element: 'Glacio',
    weapon: 'Gauntlets'
  },
  {
    id: 15,
    name: 'Lumi',
    slug: 'lumi',
    toa_cat: 'hybrid',
    toa_rating: 6,
    toa_tags: 'ST',
    ww_cat: 'hybrid',
    ww_rating: 6,
    ww_tags: 'ST',
    rarity: 4,
    element: 'Electro',
    weapon: 'Broadblade'
  },
  {
    id: 16,
    name: 'Mortefi',
    slug: 'mortefi',
    toa_cat: 'hybrid',
    toa_rating: 10,
    toa_tags: 'Coord, ST',
    ww_cat: 'hybrid',
    ww_rating: 10,
    ww_tags: 'Coord, ST',
    rarity: 4,
    element: 'Fusion',
    weapon: 'Pistols'
  },
  {
    id: 17,
    name: 'Phoebe',
    slug: 'phoebe',
    toa_cat: 'dps',
    toa_rating: 11,
    toa_tags: 'AoE, Debuff',
    ww_cat: 'dps',
    ww_rating: 8,
    ww_tags: 'AoE, Cancel, Debuff, Expert +2',
    rarity: 5,
    element: 'Spectro',
    weapon: 'Rectifier'
  },
  {
    id: 18,
    name: 'Roccia',
    slug: 'roccia',
    toa_cat: 'hybrid',
    toa_rating: 9,
    toa_tags: 'AoE',
    ww_cat: 'hybrid',
    ww_rating: 11,
    ww_tags: 'AoE',
    rarity: 5,
    element: 'Havoc',
    weapon: 'Gauntlets'
  },
  {
    id: 32,
    name: 'Rover (Aero)',
    slug: 'rover-aero',
    toa_cat: 'support',
    toa_rating: 6,
    toa_tags: 'Debuff, Heal',
    ww_cat: 'support',
    ww_rating: 6,
    ww_tags: 'Debuff, Heal',
    rarity: 5,
    element: 'Aero',
    weapon: 'Sword'
  },
  {
    id: 19,
    name: 'Rover (Spectro)',
    slug: 'rover-spectro',
    toa_cat: 'hybrid',
    toa_rating: 8,
    toa_tags: 'Cleave, Debuff, Heal, Multirole',
    ww_cat: 'hybrid',
    ww_rating: 8,
    ww_tags: 'Cancel, Cleave, Debuff, Heal, Multirole',
    rarity: 5,
    element: 'Spectro',
    weapon: 'Sword'
  },
  {
    id: 20,
    name: 'Rover (Havoc)',
    slug: 'rover-havoc',
    toa_cat: 'dps',
    toa_rating: 10,
    toa_tags: 'Cleave, Heal, Multirole',
    ww_cat: 'dps',
    ww_rating: 9,
    ww_tags: 'Cleave, Heal',
    rarity: 5,
    element: 'Havoc',
    weapon: 'Sword'
  },
  {
    id: 21,
    name: 'Sanhua',
    slug: 'sanhua',
    toa_cat: 'hybrid',
    toa_rating: 11,
    toa_tags: 'Cancel, Cleave',
    ww_cat: 'hybrid',
    ww_rating: 9,
    ww_tags: 'Cancel, Cleave',
    rarity: 4,
    element: 'Glacio',
    weapon: 'Sword'
  },
  {
    id: 22,
    name: 'Taoqi',
    slug: 'taoqi',
    toa_cat: 'hybrid',
    toa_rating: 7,
    toa_tags: 'Cleave, Heal, Shield, Multirole',
    ww_cat: 'hybrid',
    ww_rating: 6,
    ww_tags: 'Cleave, Heal, Shield, Multirole',
    rarity: 4,
    element: 'Havoc',
    weapon: 'Broadblade'
  },
  {
    id: 23,
    name: 'The Shorekeeper',
    slug: 'the-shorekeeper',
    toa_cat: 'support',
    toa_rating: 11,
    toa_tags: 'Heal',
    ww_cat: 'support',
    ww_rating: 11,
    ww_tags: 'Heal',
    rarity: 5,
    element: 'Spectro',
    weapon: 'Rectifier'
  },
  {
    id: 24,
    name: 'Verina',
    slug: 'verina',
    toa_cat: 'support',
    toa_rating: 11,
    toa_tags: 'Coord, Heal',
    ww_cat: 'support',
    ww_rating: 11,
    ww_tags: 'Coord, Heal',
    rarity: 5,
    element: 'Spectro',
    weapon: 'Rectifier'
  },
  {
    id: 25,
    name: 'Xiangli Yao',
    slug: 'xiangli-yao',
    toa_cat: 'dps',
    toa_rating: 10,
    toa_tags: 'Cancel, Cleave, Ult',
    ww_cat: 'dps',
    ww_rating: 10,
    ww_tags: 'Cancel, Cleave, Ult',
    rarity: 5,
    element: 'Electro',
    weapon: 'Gauntlets'
  },
  {
    id: 26,
    name: 'Yangyang',
    slug: 'yangyang',
    toa_cat: 'hybrid',
    toa_rating: 8,
    toa_tags: 'AoE, Cancel, Expert +1',
    ww_cat: 'hybrid',
    ww_rating: 10,
    ww_tags: 'AoE, Cancel',
    rarity: 4,
    element: 'Aero',
    weapon: 'Sword'
  },
  {
    id: 27,
    name: 'Yinlin',
    slug: 'yinlin',
    toa_cat: 'hybrid',
    toa_rating: 9,
    toa_tags: 'AoE, Cancel, Coord',
    ww_cat: 'hybrid',
    ww_rating: 10,
    ww_tags: 'AoE, Cancel, Coord',
    rarity: 5,
    element: 'Electro',
    weapon: 'Rectifier'
  },
  {
    id: 28,
    name: 'Youhu',
    slug: 'youhu',
    toa_cat: 'support',
    toa_rating: 7,
    toa_tags: 'Heal',
    ww_cat: 'support',
    ww_rating: 6,
    ww_tags: 'Heal',
    rarity: 4,
    element: 'Glacio',
    weapon: 'Gauntlets'
  },
  {
    id: 29,
    name: 'Yuanwu',
    slug: 'yuanwu',
    toa_cat: 'support',
    toa_rating: 6,
    toa_tags: 'Coord, Shield',
    ww_cat: 'support',
    ww_rating: 6,
    ww_tags: 'Coord, Shield',
    rarity: 4,
    element: 'Electro',
    weapon: 'Gauntlets'
  },
  {
    id: 30,
    name: 'Zhezhi',
    slug: 'zhezhi',
    toa_cat: 'hybrid',
    toa_rating: 11,
    toa_tags: 'Cleave, Coord',
    ww_cat: 'hybrid',
    ww_rating: 8,
    ww_tags: 'Cleave, Coord',
    rarity: 5,
    element: 'Glacio',
    weapon: 'Rectifier'
  }
];
